import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ChequeRegister, ChequeRegisterCreate, ChequeRegisterFilter } from '../data/chequeRegister';

export function createChequeRegisterService(client: AxiosInstance) {
  return createCrudService<ChequeRegister, ChequeRegisterCreate, ChequeRegisterFilter>(
    client,
    '/accounting/ChequeRegister',
    'id',
  );
}

export type ChequeRegisterService = CrudService<ChequeRegister, ChequeRegisterCreate, ChequeRegisterFilter>;
